import React, { useEffect, useState } from "react";
import styles from "./otpVerification.module.css";
import { useNavigate, useSearchParams } from "react-router-dom";
import OtpInput from "react-otp-input";
import OtpTimer from "otp-timer";
import Button from "common/Button";
import axios from "axios";
import Toast, { resendOtpToEmail } from "utils";

const OtpVerfication = () => {
  const navigate = useNavigate();

  const [searchParams] = useSearchParams();

  const email = searchParams.get("email");


  const [otp, setOtp] = useState("");

  useEffect(()=>{
    if(!email){
      navigate("/signup")
    }
  },[])
  const handleSubmit = async (e) => {
    e.preventDefault();
    if(otp?.trim()?.length != 4){
      return Toast().Info("Please Fill OTP")
    }
    try {
      // Toast().Loading("Loading")
      const response = await axios.post(
        `${process.env.REACT_APP_API_BASE_URL}/auth/verify-otp`,
        {
          email,
          otp,
          role:"admin"
        }
      );
      if (response?.data?.success) {
        Toast().Success(response?.data?.message || "something went wrong");
        navigate(`/`);
      }
    } catch (error) {
      Toast().Error(
        error?.response?.data?.message ||
          error?.response?.data?.errors?.[0]?.msg
      );
    }
  };

  const resendOtp = async () => {
    try {
      await resendOtpToEmail(email);
    } catch (error) {}
  };
  return (
    <div className={styles.container}>
      <h2 htmlFor="email" className={styles.signInLabel}>
        OTP Verification
      </h2>

      <div className={styles.formContainer}>
        <form onSubmit={handleSubmit}>
          <div className={styles.otpLabel}>
            Enter the 4-digit code send to you at <br />
            {email}
          </div>
          <OtpInput
            value={otp}
            onChange={setOtp}
            containerStyle={{
              display: "flex",
              justifyContent: "center",
              alignItems: "center",
            }}
            inputStyle={{
              width: "5.8rem",
              height: "5.8rem",
              fontSize: "1.6rem",
            }}
            numInputs={4}
            renderSeparator={<span style={{ margin: "10px" }}></span>}
            renderInput={(props) => <input {...props} />}
          />
          <div className={styles.otpInfo}>
            Didn’t receive OTP?
            <OtpTimer
              text=" "
              buttonText="Resend"
              textColor="red"
              fontFamily="Medium !important"
              fontSize=" 20px"
              buttonColor="rgb(10, 213, 201)"
              background="none"
              resend={() => resendOtp()}
              seconds={59}
              minutes={4}
            />
          </div>
          <div className={styles.formGroup}>
            <Button
              label={"Verify to Sign In"}
              buttonOverrideStyle={styles.button_}
            />
          </div>
        </form>
        <div className={styles?.divider}></div>
        <div className={styles.signup}>
          <div className={styles.signUpInfo}>Already have a Flow account?</div>
          <button
            className={styles.registerButton}
            onClick={() => navigate("/")}
          >
            Sign In
          </button>
        </div>
      </div>
    </div>
  );
};

export default OtpVerfication;
